import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import SpinnerComponent from '../components/SpinnerComponent';
import * as Yup from 'yup';
import { WorkTaskGroup } from '../models/worktaskgroup';
import { WorkTaskGroupService } from '../services/worktaskgroup.service';
import { UploadService } from '../services/upload.service';

interface IState {
    taskGroup: WorkTaskGroup;
    isLoading: boolean;
    isUploading: boolean;
    isEdit: boolean;
}

export class WorkTaskGroupEditPage extends React.Component<any, IState> {

    constructor(props: any) {
        super(props);

        this.state = {
            taskGroup: new WorkTaskGroup(),     
            isLoading: false,
            isUploading: false,
            isEdit: false
          };
    }

    componentDidMount() {
        let id = this.props.match.params.id ? this.props.match.params.id : 0;

        if (id !== 0) {
          this.setState({ isLoading: true });

          WorkTaskGroupService.getById(id)
            .then(
              response => {
                this.setState({
                  taskGroup: response,            
                  isLoading: false,
                  isEdit: true
                });
              },
              error => {
                this.setState({ isLoading: false });
              }
            );
        }
    }

    uploadFile = (e, setFieldValue) => {
        this.setState({ isUploading: true });

        const file = e.target.files[0] as File;
        const formData = new FormData();
        formData.append("file", file);

        UploadService.uploadFile(formData)
            .then((responseText) => responseText)
            .catch(() => {
                this.setState({ isUploading: false });
            })
            .then((response) => {
                // set uploaded image url to data
                let newState = Object.assign({}, this.state.taskGroup);
                newState.groupImage = response as string;
                setFieldValue('groupImage', newState.groupImage);
                this.setState({ taskGroup: newState, isUploading: false });
            });
    };

    visibilityChanged = (e, setFieldValue) => {
        let newState = Object.assign({}, this.state.taskGroup);
        newState.groupVisible = !newState.groupVisible;
        setFieldValue('groupVisible', newState.groupVisible);
        this.setState({ taskGroup: newState });
    };

    render() {
        return (
            <div className="col-md-6">
                {this.state.isEdit ? 
                  <h1>Uredi grupu zadataka</h1> : <h1>Kreiraj novu grupu zadataka</h1>}
                {this.state.isLoading ? <SpinnerComponent /> : (
                <Formik
                    initialValues={this.state.taskGroup}
                    validationSchema={Yup.object().shape({
                        groupName: Yup.string().required('Naziv grupe je potreban'),
                        groupImage: Yup.string().required('Slika grupe je potrebna'),
                        groupOrderKey: Yup.number().required('Unesite broj za poredak'),
                        
                    })}
                    onSubmit={(values, { setStatus, setSubmitting, setError }) => {
                        setStatus();  
                        setError(null);                                     

                        // set uploaded image URL to form input value
                        values.groupImage = this.state.taskGroup.groupImage;

                        WorkTaskGroupService.createOrUpdate(values)
                            .then(
                                () => {
                                    setSubmitting(false);
                                    setStatus("Uspješno spremljeno!");
                                },
                                error => {
                                    setSubmitting(false);
                                    setError(error);
                                }
                            );
                    }}
                    render={({ errors, status, touched, isSubmitting, error, setFieldValue, setStatus, setError, setSubmitting }) => (
                        <Form>
                            <div className="form-group">
                                <label htmlFor="groupName">Naziv grupe zadataka</label>
                                <Field name="groupName" type="text" className={'form-control' + (errors.groupName && touched.groupName ? ' is-invalid' : '')} />
                                <ErrorMessage name="groupName" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="groupOrderKey">Poredak grupe (od najmanjeg broja do najvećeg)</label>
                                <Field name="groupOrderKey" type="number" className={'form-control' + (errors.groupOrderKey && touched.groupOrderKey ? ' is-invalid' : '')} />
                                <ErrorMessage name="groupOrderKey" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="groupVisible">Grupa vidljiva unutar mobilne app?</label>
                                <Field name="groupVisible" type="checkbox" 
                                       checked={this.state.taskGroup.groupVisible} 
                                       onChange={data => this.visibilityChanged(data, setFieldValue)}
                                       className={'form-control' + (errors.groupVisible && touched.groupVisible ? ' is-invalid' : '')} />
                                <ErrorMessage name="groupVisible" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="groupImage">Slika grupe zadataka</label>
                                <Field name="image" type="file" accept="image/png, image/jpeg" onChange={data => this.uploadFile(data, setFieldValue)} />
                            </div>
                            <div className="form-group">
                                <Field name="groupImage" type="text" disabled className={'form-control' + (errors.groupImage && touched.groupImage ? ' is-invalid' : '')} />
                                <ErrorMessage name="groupImage" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <img src={this.state.taskGroup.groupImage} style={{maxHeight:200}} />
                            </div>
                            <div className="form-group">
                                {!this.state.isUploading &&
                                    <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                    {this.state.isEdit ? 
                                        <span>Spremi</span> : <span>Kreiraj novu grupu zadataka</span>}
                                    </button>
                                }
                                {this.state.isEdit &&
                                    <button className="btn btn-danger pull-right" disabled={isSubmitting}
                                        onClick={e => {
                                            e.preventDefault();
                                            if (window.confirm("Jeste li sigurni da želite obrisati ovaj zapis?")) {
                                                
                                                setStatus();
                                                setError(null);
                                                WorkTaskGroupService.deleteById(this.state.taskGroup.id)
                                                .then(
                                                    () => {
                                                        setSubmitting(false);
                                                        setStatus("Uspješno obrisano!");
                                                    },
                                                    error => {
                                                        setSubmitting(false);
                                                        setError(error);
                                                    }
                                                );
                                            }
                                        }}
                                    >
                                        Izbrisati
                                    </button>
                                }  
                                {isSubmitting || this.state.isUploading &&
                                    <SpinnerComponent/>
                                }                                
                            </div>
                            {error &&
                                <div className={'alert alert-danger'}>{error}</div>
                            }
                            {status &&
                                <div className={'alert alert-success'}>{status}</div>
                            }
                        </Form>
                    )}
                />
                )}
                <button
                    className="button icon-left"
                    onClick={this.props.history.goBack}>
                    Povratak
                </button>
            </div>
        )
    }
}